import React from 'react'

interface Props {
  percent: number
  size?: number
  strokeWidth?: number
}

const CircularProgress: React.FC<Props> = ({
  percent,
  size = 80,
  strokeWidth = 6,
}) => {
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (percent / 100) * circumference

  return (
    <svg width={size} height={size} className="-rotate-90">
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        fill="none"
        className="text-gray-300"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        className="text-blue-600 transition-all duration-300"
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dy="0.3em"
        className="text-sm font-semibold fill-gray-700 dark:fill-gray-200 rotate-90"
      >
        {percent}%
      </text>
    </svg>
  )
}

export default React.memo(CircularProgress)
